module.exports = __webpack_public_path__ + "static/media/scenarios.6f3ca3e8.png";